import Vue from 'vue'
import Router from 'vue-router'
const EmptyRouterView = () => import(/* webpackChunkName: 'common' */ '@/components/EmptyRouterView')
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/403',
      name: '403',
      component: () => import(/* webpackChunkName: '403' */ '@/components/403')
    },
    {
      path: '/error',
      name: 'Error',
      component: () => import(/* webpackChunkName: 'error' */ '@/components/Error')
    },
    {
      path: '/',
      redirect: '/id/user-profile'
    },
    {
      path: '/id',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          redirect: 'user-profile'
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import(/* webpackChunkName: 'dashboard' */ '@/components/secure/dashboard/Dashboard')
        },
        {
          path: 'user-profile',
          name: 'UserProfile',
          component: () => import(/* webpackChunkName: 'profile' */ '@/components/secure/user-profile/UserProfile')
        },
        {
          path: 'create-account',
          name: 'CreateAccount',
          component: () => import(/* webpackChunkName: 'accounts' */ '@/components/secure/accounts/CreateAccount')
        }
      ]
    }
  ]
})
